module.exports = __webpack_public_path__ + "img/blue_010.825b4dac.png";